import { createApi } from '@reduxjs/toolkit/query/react';
import { CONFIGS_API } from 'services/constants';
import { rawBaseQuery } from 'services/shared';

export const configsApi = createApi({
  reducerPath: CONFIGS_API,
  baseQuery: rawBaseQuery,
  endpoints: (builder) => ({
    getRefPricing: builder.query<string[], void>({
      query: () => encodeURI(`/configs/ref-pricing`),
    }),
  }),
});

export const { useGetRefPricingQuery } = configsApi;
